import {RootLayout} from '@raison/ui-kit';
import React from 'react';
import {TransactionFilters} from './TransactionFilters/TransactionFilters';
import {Transactions} from './Transactions/Transactions';

export const TransactionsPage = () => {
    return (
        <RootLayout title='Transactions'>
            <TransactionFilters />
            <Transactions />
        </RootLayout>
    );
};
